<template>
    <div class="accordion-panel">
        <div class="accordion-panel__header" :class="{'active': isActive}" @click="headlineClickHandler">
            Logo hinzufügen
        </div>

        <height-transition>
            <div class="accordion-panel__body" v-show="isActive">
                <div class="accordion-panel__body__inner">
                    <!-- LOGO UPLOAD -->
                    <div class="panel-section-headline has-tooltip" @click="showUploadModal = true">
                        Logo hochladen
                    </div>
                    <div class="upload"
                         :class="{'upload--dragover': uploadDragOver || hasFile}"
                         @drop="uploadWrapperDropHandler"
                         @dragover="uploadDragOverHandler"
                         @dragleave="uploadDragLeaveHandler"
                         @drag="haltDragEvent"
                         @dragenter="haltDragEvent"
                         @dragstart="haltDragEvent"
                         @dragend="haltDragEvent"
                    >
                        <div class="upload__zone" v-show="!hasFile">
                            <input class="upload__zone__file" type="file" accept="image/jpeg,image/jpg,image/png,.pdf,.eps" :id="uniqid('file')" ref="file"
                                   @change="fileInputChangeHandler">
                            <label :for="uniqid('file')" v-show="!isUploading">
                                <svg height="41" viewBox="0 0 43 41" width="43" xmlns="http://www.w3.org/2000/svg">
                                    <g style="stroke:#dcb47d;stroke-width:2;fill:none;fill-rule:evenodd;stroke-linecap:round;stroke-linejoin:round"
                                       transform="translate(1 1)">
                                        <path d="m21.3541667 7.3125v24.375"/>
                                        <path d="m30.75 16.25-9.3958333-8.9375-9.3958334 8.9375"/>
                                        <path d="m29.8958333.8125h8.5416667c.9434864 0 1.7083333.72753728 1.7083333 1.625v34.125c0 .8974627-.7648469 1.625-1.7083333 1.625h-8.5416667"/>
                                        <path d="m11.1041667.8125h-8.5416667c-.94348645 0-1.70833333.72753728-1.70833333 1.625v34.125c0 .8974627.76484688 1.625 1.70833333 1.625h8.5416667"/>
                                    </g>
                                </svg>
                                <span>Datei auswählen oder hier ablegen</span>
                            </label>
                            <label :for="uniqid('file')" v-show="isUploading">
                                <svg class="lds-spinner" width="43px" height="43px" xmlns="http://www.w3.org/2000/svg"
                                     xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100"
                                     preserveAspectRatio="xMidYMid"
                                     style="background-image: none; background-position: initial initial; background-repeat: initial initial;">
                                    <g transform="rotate(0 50 50)">
                                        <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                                            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                                     begin="-1.0999999999999999s" repeatCount="indefinite"></animate>
                                        </rect>
                                    </g>
                                    <g transform="rotate(30 50 50)">
                                        <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                                            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                                     begin="-1s" repeatCount="indefinite"></animate>
                                        </rect>
                                    </g>
                                    <g transform="rotate(60 50 50)">
                                        <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                                            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                                     begin="-0.8999999999999999s" repeatCount="indefinite"></animate>
                                        </rect>
                                    </g>
                                    <g transform="rotate(90 50 50)">
                                        <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                                            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                                     begin="-0.7999999999999999s" repeatCount="indefinite"></animate>
                                        </rect>
                                    </g>
                                    <g transform="rotate(120 50 50)">
                                        <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                                            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                                     begin="-0.7000000000000001s" repeatCount="indefinite"></animate>
                                        </rect>
                                    </g>
                                    <g transform="rotate(150 50 50)">
                                        <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                                            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                                     begin="-0.6s" repeatCount="indefinite"></animate>
                                        </rect>
                                    </g>
                                    <g transform="rotate(180 50 50)">
                                        <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                                            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                                     begin="-0.5s" repeatCount="indefinite"></animate>
                                        </rect>
                                    </g>
                                    <g transform="rotate(210 50 50)">
                                        <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                                            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                                     begin="-0.39999999999999997s" repeatCount="indefinite"></animate>
                                        </rect>
                                    </g>
                                    <g transform="rotate(240 50 50)">
                                        <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                                            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                                     begin="-0.3s" repeatCount="indefinite"></animate>
                                        </rect>
                                    </g>
                                    <g transform="rotate(270 50 50)">
                                        <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                                            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                                     begin="-0.19999999999999998s" repeatCount="indefinite"></animate>
                                        </rect>
                                    </g>
                                    <g transform="rotate(300 50 50)">
                                        <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                                            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                                     begin="-0.09999999999999999s" repeatCount="indefinite"></animate>
                                        </rect>
                                    </g>
                                    <g transform="rotate(330 50 50)">
                                        <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                                            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                                     begin="0s" repeatCount="indefinite"></animate>
                                        </rect>
                                    </g>
                                </svg>
                                <span>Datei wird hochgeladen...</span>
                            </label>
                        </div>
                        <div class="upload__preview" v-show="hasFile">
                            <button type="button" class="upload__preview__delete"
                                    @click="uploadDeleteButtonClickHandler"></button>
                            <img src="" ref="uploadPreview">
                        </div>
                    </div>

                    <p>
                        <strong>Hinweis:</strong> Folgende Dateiformate werden unterstützt: .eps, .pdf, .png, .jpg. Das
                        Logo muss in einer Auflösung von mindestens 300 dpi bzw. 1323 x 1323 Pixeln bei 72 dpi
                        vorliegen.
                        <br><br>
                        <strong>Bitte beachten:</strong> Drucktechnisch bedingt kann es zu handelsüblichen Abweichungen
                        bei Ausführungen, Farb- und
                        Formgebungen zwischen Abbildungen im Online-Konfigurator und dem fertigen Produkt kommen.
                    </p>

                    <!-- LOGO FARBE -->
                    <div class="panel-section-headline has-tooltip" @click="showColorModal = true">Farbe auswählen</div>
                    <color-selector :attribute="colorAttribute"
                                    :selected="selectedColor"
                                    @selected:color="colorSelectedHandler"
                    ></color-selector>

                    <!-- LOGO SKALIERUNG -->
                    <div class="panel-section-headline has-tooltip" @click="showScaleModal = true">Größe auswählen</div>
                    <scale-selector :scales="scales"
                                    :selected="selectedScale"
                                    v-if="hasScales"
                                    @selected:scale="scaleSelectedHandler"
                    ></scale-selector>
                </div>
            </div>
        </height-transition>

        <!-- Upload Error Modal -->
        <ui-modal v-show="showUploadErrorModal" @close:clicked="showUploadErrorModal = false">
            <template v-slot:title>
                <span v-if="uploadError !== null">
                    {{ uploadError.title }}
                </span>
            </template>
            <template v-slot:content>
                <p v-if="uploadError !== null">
                    {{ uploadError.message }}
                </p>
            </template>
            <template v-slot:footer>
                <button type="button" class="button button--white button--outline button--modal"
                        @click="uploadErrorModalCloseClickHandler">
                    <span>schließen</span>
                </button>
            </template>
        </ui-modal>

        <!-- Icon Modal -->
        <ui-modal v-show="showUploadModal" @close:clicked="showUploadModal = false">
            <template v-slot:title>Upload</template>
            <template v-slot:content>
                <p>
                    Laden Sie Ihr Logo hoch, das Sie an der gewählten Position auf dem Geschirr
                    anbringen möchten. Bitte wählen Sie die Bilddatei Ihres Logos vom Speicher Ihres Geräts
                    und
                    laden Sie sie per Klick hoch. Die Auflösung muss mindestens 300 dpi betragen.
                </p>
            </template>
        </ui-modal>

        <!-- Color Modal -->
        <ui-modal v-show="showColorModal" @close:clicked="showColorModal = false">
            <template v-slot:title>Icon - Farbauswahl</template>
            <template v-slot:content>
                <p>
                    Falls Ihr Logo nicht bereits farbig ist, können Sie hier eine Farbe aus unserer Palette
                    wählen.
                </p>
            </template>
        </ui-modal>

        <!-- Scale Modal -->
        <ui-modal v-show="showScaleModal" @close:clicked="showScaleModal = false">
            <template v-slot:title>Logo - Skalierung</template>
            <template v-slot:content>
                <p>
                    Bitte legen Sie hier die Größe für Ihr Logo fest.
                </p>
            </template>
        </ui-modal>

        <ui-modal v-show="showColorWarningModal" @close:clicked="showColorWarningModal = false">
            <template v-slot:title>Mehrfarbigkeit</template>
            <template v-slot:content>
                <p>
                    Zur Zeit ist nur der Druck einfarbiger Motive möglich. Deshalb wird Ihr hochgeladenes Logo automatisch in Schwarz eingefärbt. 
                    Sie können auf Wunsch eine andere Farbe für Ihr Logo über die vorgegebene Farbpalette auswählen.

                    <br><br><strong>Bei Fragen
                    wenden Sie sich an unseren Customer Service: <a href="tel:0080068648110">00800 / 6864
                        8110</a>.</strong>
                </p>
            </template>
        </ui-modal>
    </div>
</template>

<script>
    import AttributeTree  from "../../../expivi/attributes/AttributeTree"
    import AttributeValue from "../../../expivi/attributes/AttributeValue"
    import Attribute      from "../../../expivi/attributes/Attribute"
    import UploadClient   from "../../../http/woo/UploadClient"

    export default {
        name:     "UploadPanel",
        props:    {
            customization:  {
                required: true,
                type:     AttributeValue
            },
            position:       {
                required: true,
                type:     AttributeTree
            },
            colorAttribute: {
                required: true,
                type:     Attribute
            },
            scales:         {
                required: true,
                type:     Array,
                default:  function () {
                    return []
                }
            }
        },
        data:     function () {
            return {
                node:                  null,
                attribute:             null,
                attributeValuable:     null,
                targetMaterial:        null,
                texture:               null,
                defaultTexture:        null,
                materialManager:       null,
                uploadError:           null,
                uploadClient:          null,
                uploadDragOver:        false,
                showIconModal:         false,
                showColorModal:        false,
                showScaleModal:        false,
                showColorWarningModal: false,
                showUploadModal:       false,
                showUploadErrorModal:  false,
                hasFile:               false,
                isUploading:           false
            }
        },
        computed: {
            /**
             * Returns the slug of the position. Used for dynamic store handling.
             */
            positionSlug: function () {
                return this.position.getRoot().getSlug()
            },

            /**
             * Returns the selected color as defined in the position's store.
             */
            selectedColor: function () {
                return this.$store.state[this.positionSlug].color
            },

            /**
             * Returns the selected scale as defined in the position's store
             * @returns {*}
             */
            selectedScale: function () {
                return this.$store.state[this.positionSlug].scale
            },

            /**
             * Verify if we have selectable scales
             * @returns {boolean}
             */
            hasScales: function () {
                return this.scales.length > 0
            },

            isActive: function () {
                return this.callStoreGetter('hasUploadCustomization')
            }
        },
        watch:    {
            /**
             * Check if the isActive computed property changed and
             */
            isActive: function (isActive) {
                if (isActive === false) {
                    this.$refs.uploadPreview.src = null
                    this.hasFile                 = false
                    this.texture                 = this.defaultTexture.clone()
                    this.updateTexture()
                }
            }
        },
        created:  function () {
            this.uploadClient = new UploadClient();
            this.node         = this.position.filterByType('mytw_conf_position_upload')

            if (this.node.hasAttributeValues()) {
                this.attribute         = this.node.getAttributeValues()[0]
                this.attributeValuable = this.attribute.getAttributeValueValuable()

                // Load the default texture, that is applied when the uploaded image is removed
                this.$expiviReady.then(expivi => {
                    if (this.materialManager === null) {
                        expivi.managers.resolveMaterialManager().then(manager => {
                            this.targetMaterial = manager
                                .resolveMaterialById(this.attributeValuable.material_id, resolvedMaterial => {
                                    this.defaultTexture = resolvedMaterial.map
                                })
                        })
                    }
                })
            }
        },
        methods:  {
            /**
             * Call a store getter
             */
            callStoreGetter(getterName) {
                let slug = this.positionSlug
                return this.$store.getters[slug + '/' + getterName]
            },

            /**
             * Call a store mutation
             */
            callStoreMutation(mutationName, payload) {
                let slug = this.positionSlug
                return this.$store.commit(slug + '/' + mutationName, payload)
            },

            /**
             * Maps the updateCustomization mutation to the dynamic store module
             *
             * @param customization
             */
            updateCustomization: function (customization) {
                this.callStoreMutation('updateCustomization', customization)
            },

            /**
             * Pass the selected color to the parent component
             */
            colorSelectedHandler: function (color) {
                this.$emit('selected:color', color)
            },

            /*+
             * Pass the selected scale event to the parent component
             */
            scaleSelectedHandler: function (scale) {
                this.$emit('selected:scale', scale)
            },

            /**
             * Handles the click on the headline and thus the enabling of the icon customization.
             */
            headlineClickHandler: function () {
                if (this.isActive === false) {
                    this.$expiviReady.then(expivi => {
                        let customizationOptionsNode = this.position.filterByType('mytw_conf_position_customization')

                        this.updateCustomization(this.customization)
                        expivi.setProductAttribute(customizationOptionsNode.getId(), this.customization.getId())
                    })
                }
            },

            fileInputChangeHandler: function ($event) {
                if ($event.target.files.length > 0) {
                    let file = $event.target.files[0];
                    this.processFile(file);
                }
            },

            processFile: function (file) {
                let reader = new FileReader()

                let allowedTypes = [
                    'application/postscript',
                    'application/pdf',
                    'image/png',
                    'image/jpeg'
                ];

                let type = file['type'];
                if(!(allowedTypes).includes(type)) {
                    this.uploadError = {
                        title:   'Dateiformat nicht unterstützt',
                        message: 'Folgende Dateiformate werden unterstützt: .eps, .pdf, .png, .jpg.'
                    }
                    this.showUploadErrorModal = true
                    return
                }


                reader.onload = () => {
                    this.isUploading = true
                    this.uploadClient.upload(file).then(response => {
                        this.isUploading        = false
                        let expiviData          = response.data.data
                        expiviData.image_source = response.data.data.texture
                        this.$expiviReady.then(expivi => expivi.setProductAttribute(this.node.getId(), expiviData))
                        this.hasFile                 = true
                        this.$refs.uploadPreview.src = response.data.data.texture
                        let image                    = new Image()
                        let canvas                   = document.createElement('canvas')
                        let context                  = canvas.getContext('2d')

                        canvas.style.display = 'none'
                        canvas.setAttribute('id', 'texture')
                        document.body.appendChild(canvas)

                        this.texture = new THREE.Texture(canvas)

                        image.crossOrigin = 'Anonymous'

                        image.onload = () => {
                            // Create the texture canvas, that we try to colorize
                            //canvas.width  = 1250
                            //canvas.height = 800
                            canvas.width  = 512 * this.attributeValuable.ratio
                            canvas.height = 512

                            // Draw a white background first
                            context.fillStyle = '#ffffff'
                            context.fillRect(0, 0, canvas.width, canvas.height)

                            // Contain the texture image within the canvas size
                            let widthRatio          = canvas.width / image.width
                            let heightRatio         = canvas.height / image.height
                            let normalizationFactor = widthRatio < heightRatio ? widthRatio : heightRatio
                            let normalizedWidth     = image.width * normalizationFactor
                            let normalizedHeight    = image.height * normalizationFactor

                            //context.drawImage(image, 0, 0)
                            context.drawImage(image, (canvas.width - normalizedWidth) / 2, (canvas.height - normalizedHeight) / 2, normalizedWidth, normalizedHeight)

                            // Make the white part of the image transparent, and the non-white part white
                            // We need to make it white to colorize the texture within expivi
                            let imageData = context.getImageData(0, 0, canvas.width, canvas.height)
                            let pixels    = imageData.data

                            // Define the colors we need to display the colored logo to the user
                            let transparent = {r: 0, g: 0, b: 0, a: 0}
                            let white       = {r: 255, g: 255, b: 255, a: 255}
                            let colors      = []

                            for (let i = 0; i < pixels.length; i += 4) {
                                let r = pixels[i], g = pixels[i + 1], b = pixels[i + 2];

                                if (i === 0) {
                                    colors.push(JSON.stringify({r, g, b}))
                                } else if (colors.length < 3) {
                                    let currentColor = JSON.stringify({r, g, b})
                                    if (!colors.includes(currentColor)) {
                                        colors.push(currentColor)

                                        if (colors.length === 3) {
                                            this.showColorWarningModal = true
                                        }
                                    }
                                }

                                if (r >= 225 && g >= 225 && b >= 225) {
                                    pixels[i]     = transparent.r;
                                    pixels[i + 1] = transparent.g;
                                    pixels[i + 2] = transparent.b;
                                    pixels[i + 3] = transparent.a;
                                } else {
                                    pixels[i]     = white.r;
                                    pixels[i + 1] = white.g;
                                    pixels[i + 2] = white.b;
                                    pixels[i + 3] = white.a;
                                }
                            }

                            context.globalCompositeOperation = 'source-atop'
                            context.globalAlpha              = 1
                            context.fillStyle                = 'white'
                            context.fillRect(0, 0, canvas.width, canvas.height)
                            context.globalCompositeOperation = 'source-over'

                            // Update the canvas accordingly
                            context.putImageData(imageData, 0, 0)

                            this.texture.format      = THREE.RGBAFormat
                            this.texture.anisotropy  = 8
                            this.texture.needsUpdate = true

                            // Trigger the rerendering
                            this.updateTexture()
                        }

                        // Update the images source attribute to update the texture
                        image.src = response.data.data.texture
                    }).catch(error => {
                        console.log('Fileupload: An error has occured', error, error.response)
                        this.hasFile     = false
                        this.isUploading = false

                        if (
                            error.response && error.response.data && error.response.data.data
                        ) {
                            this.uploadError = error.response.data.data
                        } else {
                            this.uploadError = {
                                title:   'Fehler',
                                message: 'Beim hochladen der Datei ist ein unbekannter Fehler aufgetreten'
                            }
                        }

                        this.showUploadErrorModal = true
                        this.$refs.file.value     = null
                    })
                }

                reader.readAsDataURL(file)
            },

            /**
             * Updates the texture for the uploaded logo on the product and
             */
            updateTexture: function () {
                if (this.targetMaterial === null) {
                    this.$expiviReady.then(expivi => {
                        if (this.materialManager === null) {
                            expivi.managers.resolveMaterialManager().then(manager => {
                                this.materialManager = manager

                                if (this.texture !== null) {
                                    this.targetMaterial = manager
                                        .resolveMaterialById(this.attributeValuable.material_id, resolvedMaterial => {
                                            this.targetMaterial           = resolvedMaterial
                                            this.targetMaterial.magFilter = THREE.LinearFilter

                                            if (this.attributeValuable.repeat_type === 'repeat') {
                                                this.targetMaterial.wrapS = this.targetMaterial.wrapT = THREE.RepeatWrapping
                                            } else if (this.attributeValuable.repeat_type === 'clamp') {
                                                this.targetMaterial.wrapS = this.targetMaterial.wrapT = THREE.ClampToEdgeWrapping
                                            }

                                            this.targetMaterial.map         = this.texture
                                            this.targetMaterial.transaction = true
                                            this.targetMaterial.transparent = true
                                            this.targetMaterial.needsUpdate = true
                                            expivi._dispatch('render_frame')
                                        })
                                }
                            })
                        }
                    })
                } else {
                    this.targetMaterial.map         = this.texture
                    this.targetMaterial.needsUpdate = true
                    this.$expiviReady.then(expivi => expivi._dispatch('render_frame'))
                }
            },

            /**
             * Handle the click of the close button of the error modal
             */
            uploadErrorModalCloseClickHandler: function () {
                this.addDataLayer({
                    'event': 'mytw_conf_logoupload_error_close'
                })

                this.showUploadErrorModal = false
            },

            /**
             * Handles the dropping of files to the dropzone area
             */
            uploadWrapperDropHandler: function ($event) {
                this.haltDragEvent($event)
                this.uploadDragOver = false

                if ($event.dataTransfer.items.length > 0) {
                    // Get the first of the dropped files, we do not support the upload of multiple files
                    let file = $event.dataTransfer.items[0].getAsFile()
                    this.processFile(file)
                }
            },

            /**
             * Prevents the execution from various drag events
             *
             * @param $event
             */
            haltDragEvent: function ($event) {
                $event.preventDefault()
                $event.stopPropagation()
            },

            /**
             * Drag over state for the upload zone
             */
            uploadDragOverHandler: function ($event) {
                this.haltDragEvent($event)
                this.uploadDragOver = true
            },

            /**
             * Remove drag over state for the upload zone
             */
            uploadDragLeaveHandler: function ($event) {
                this.haltDragEvent($event)
                this.uploadDragOver = false
            },

            /**
             * Handles the click of the delete button on the preview image
             *
             * @param $event
             */
            uploadDeleteButtonClickHandler: function () {
                // Remove the preview image and set the texture back to the default
                this.$refs.file.value        = null;
                this.$refs.uploadPreview.src = null
                this.hasFile                 = false
                this.texture                 = this.defaultTexture.clone()
                this.$expiviReady.then(expivi => expivi.setProductAttribute(this.node.getId(), {
                    image_source: '',
                    original:     '',
                    texture:      ''
                }))
                this.updateTexture()
            }
        }
    }
</script>
